import React from "react";
import Slider from "react-slick";
import "../../assets/vendor/slick-master/slick/slick.scss";
import "../../assets/vendor/slick-master/slick/slick-theme.scss";
// import "~slick-carousel/slick/slick.css";//yarn added slick-carousel
// import "~slick-carousel/slick/slick-theme.css";
import CategoryCard from "../../components/CategoryCard";
import TitleGroup, { Title } from "../../components/common/TitleGroup";
import "./Categories.scss";
import { Row } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";

import { useQuery } from "react-query";
import { ApiNames, fetchData } from "../../remote-data/fetchData";
import { Loader } from "../../utils/common";
import "./Categories.scss";

function Categories() {
  const settings = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  };
  // API: GET
  const { data: postData, isLoading: isPostLoading } = useQuery(
    ApiNames.SUB_MERCHANT_CATEGORY_SEARCH,
    () =>
      fetchData(ApiNames.SUB_MERCHANT_CATEGORY_SEARCH, {
        // pathValues: [props.spaceId],
        params: { size: 100 }
      })
  );
  if (isPostLoading || !postData) return <Loader />;
  // console.log(postData && postData.data.subMerchantCategories);
  /*
  id: "25137336-cc9d-4d40-a196-2cdbb4f302ac",
  name: "Events",
  description: "Top jewelry brands",
  offerCount: 1,
  image:
    "https://dev-cdn-offer.fonepay.com/offercontent/sub_merchant_category/f7885a5459c44d4a9cb37c59ca1b375f"
  */

  return (
    <>
      <TitleGroup>
        <Title title="Popular Categories" />
        {/* <SeeAllButton /> */}
      </TitleGroup>

      {postData.data.subMerchantCategories.length < 3 ? (
        <div className="not-slick-slider mb-4">
          <Row className="row-gap-10">
            {postData.data.subMerchantCategories.map(item => (
              <Colxx key={item.id} sm="6" lg="4">
                <CategoryCard postItem={item} />
              </Colxx>
            ))}
          </Row>
        </div>
      ) : (
        <Slider className="" {...settings}>
          {postData &&
            postData.data.subMerchantCategories.map(item => (
              <div key={item.id}>
                <CategoryCard postItem={item} />
              </div>
            ))}
        </Slider>
      )}
    </>
  );
}

export default Categories;
